import type { FieldPath, UseFormReturn } from 'react-hook-form'
import type { z } from 'zod'
import type { InstallationCreateFormInput } from '@/features/installations/installation-create.schema'

const syncLatinToLocalSetValueOptions = {
  shouldValidate: false,
  shouldDirty: false,
  shouldTouch: false,
} as const

/** Mirrors Latin address fields into local fields for orgs without a separate local step. */
export function syncLatinAddressToLocalFormFields(
  form: UseFormReturn<InstallationCreateFormInput>,
) {
  const values = form.getValues()
  form.setValue('localName', values.name ?? '', syncLatinToLocalSetValueOptions)
  form.setValue('localStreet', values.street ?? '', syncLatinToLocalSetValueOptions)
  form.setValue('localStreet2', values.street2 ?? '', syncLatinToLocalSetValueOptions)
  form.setValue(
    'localStreetNumber',
    values.streetNumber ?? '',
    syncLatinToLocalSetValueOptions,
  )
  form.setValue('localPostCode', values.postCode ?? '', syncLatinToLocalSetValueOptions)
  form.setValue('localPoBox', values.poBox ?? '', syncLatinToLocalSetValueOptions)
  form.setValue('localCity', values.city ?? '', syncLatinToLocalSetValueOptions)
}

export function applyInstallationCreateZodIssuesToForm(
  form: UseFormReturn<InstallationCreateFormInput>,
  issues: z.ZodIssue[],
) {
  for (const issue of issues) {
    const firstPath = issue.path[0]
    if (typeof firstPath === 'string') {
      form.setError(firstPath as FieldPath<InstallationCreateFormInput>, {
        type: issue.code === 'custom' ? 'custom' : 'validation',
        message: issue.message,
      })
    }
  }
}
